import moment from "moment";
import { POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerListaIncidenteMovil(obj) {
    try {
        let data = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/incidente-movil/obtener-lista-incidente-movil",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            for (let i = 0; i < data.length; i++) {
                // data[i].fechaHoraIncidente = moment(data[i].fechaHoraIncidente).format("YYYY/MM/DD HH:mm");
                data[i].fechaRegistro = moment(data[i].fechaRegistro).format("YYYY/MM/DD HH:mm");
                // data[i].habilitadoLabel = data[i].habilitado === 1 ? tag("column_habilitado") : tag("column_deshabilitado");
            }
        }
        return data;
    } catch (err) {
        console.log("obtenerListaIncidenteMovil err");
        console.log(err);
        return [];
    }
}